import * as React from "react";
import { Hint } from "react-ui";
import { useState } from "react";

import { InputContainer as Input } from "../../ValueEditors/Input/InputContainer";
import { useMetrics } from "../../Internals/Metrics/MetricsProviderContext";
import { PENCIL_CLICK } from "../../metricsAction";
import { isChildOfType } from "../../TypingUtils";
import { ControlDependency } from "../../withRuntimeDependencies";
import { Icon } from "../../Icons/Icon";

import { Content, PencilButton } from "./Pencil.styles";

export interface PencilProps {
    children: React.ReactNode;
    dependencies: ControlDependency[];
    opened: boolean;
    width?: number | string;
    hint?: string;
    onOpenPencil: () => void;
    isReadOnly?: boolean;
}

export function Pencil(props: PencilProps): JSX.Element | null {
    const trackAction = useMetrics();
    const [isFocusInput, setIsFocusInput] = useState(false);

    const handleClick = () => {
        props.onOpenPencil();
        setIsFocusInput(true);
        trackAction(PENCIL_CLICK, {
            page: "UnknownPage",
            paths: props.dependencies.map(dependency => dependency.path).join(","),
        });
    };

    const childrenWithAutoFocus = React.Children.map(props.children ?? [], (child, index) =>
        isChildOfType(child, Input) && props.opened && index === 0
            ? React.cloneElement(child, { ...child.props, autoFocus: child.props.autoFocus ?? isFocusInput })
            : child
    );

    if (props.opened) {
        return <Content style={{ width: props.width }}>{childrenWithAutoFocus}</Content>;
    }

    return props.isReadOnly === true ? null : (
        <Hint text={props.hint} maxWidth={140}>
            <PencilButton onClick={handleClick} style={{ width: props.width }}>
                <Icon data-tid="EditIcon" name="ToolPencilLineIcon" />
            </PencilButton>
        </Hint>
    );
}
